import { render, staticRenderFns } from "./FooterServices.vue?vue&type=template&id=d13ec188&scoped=true"
import script from "./FooterServices.vue?vue&type=script&lang=js"
export * from "./FooterServices.vue?vue&type=script&lang=js"
import style0 from "./FooterServices.vue?vue&type=style&index=0&id=d13ec188&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13ec188",
  null
  
)

export default component.exports